import React, { useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import TrainerRow from "./TrainerRow";
import AddCategoryRateDialog from "./AddCategoryRateDialog";

const TrainersTab = ({
  trainers,
  isMobile,
  getAvailableCategories,
  onUpdateTrainerCost,
  onAddCategoryRate,
  onUpdateCategoryRate,
  onDeleteCategoryRate,
}) => {
  const [addCategoryRateDialog, setAddCategoryRateDialog] = useState({
    open: false,
    trainerId: null,
  });

  const handleOpenAddDialog = (trainerId) => {
    setAddCategoryRateDialog({ open: true, trainerId });
  };

  const handleCloseAddDialog = () => {
    setAddCategoryRateDialog({ open: false, trainerId: null });
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 2, color: "text.secondary" }}>
        Ustaw stawkę godzinową dla każdego trenera. Możesz także ustawić różne
        stawki dla różnych kategorii zajęć.
      </Typography>
      <TableContainer>
        <Table size={isMobile ? "small" : "medium"}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: 50 }}></TableCell>
              <TableCell>Trener</TableCell>
              {!isMobile && <TableCell>Email</TableCell>}
              <TableCell align="right">Stawka domyślna</TableCell>
              <TableCell align="center" sx={{ width: 100 }}>
                Akcja
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {trainers.map((trainer) => (
              <TrainerRow
                key={trainer.id}
                trainer={trainer}
                isMobile={isMobile}
                availableCategories={getAvailableCategories(trainer.id)}
                onUpdateTrainerCost={onUpdateTrainerCost}
                onOpenAddCategoryDialog={handleOpenAddDialog}
                onUpdateCategoryRate={onUpdateCategoryRate}
                onDeleteCategoryRate={onDeleteCategoryRate}
              />
            ))}
            {trainers.length === 0 && (
              <TableRow>
                <TableCell colSpan={isMobile ? 4 : 5} align="center">
                  <Typography variant="body2" color="text.secondary">
                    Brak trenerów
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <AddCategoryRateDialog
        open={addCategoryRateDialog.open}
        trainerId={addCategoryRateDialog.trainerId}
        availableCategories={
          addCategoryRateDialog.trainerId
            ? getAvailableCategories(addCategoryRateDialog.trainerId)
            : []
        }
        onClose={handleCloseAddDialog}
        onAdd={onAddCategoryRate}
      />
    </Box>
  );
};

export default TrainersTab;
